import React from "react";

import { Link } from "gatsby";

import "../../styles/common/pagination.scss";

const buildLinkPath = (basePath, page, sortSlug) => {
  return `${basePath}/${page}` + (sortSlug ? `/${sortSlug}` : '');
}

function buildList(page, numPages, basePath, sortSlug) {
  const firstPageElement = (
    <li>
      <Link to={ buildLinkPath(basePath, 1, sortSlug) }>
        <span className="label">1</span>
      </Link>
    </li>
  );
  const lastPageElement = (
    <li>
      <Link to={ buildLinkPath(basePath, numPages, sortSlug) }>
        <span className="label">{numPages}</span>
      </Link>
    </li>
  );
  const emptyElement = (
    <li><span className="empty-element"><span className="label">…</span></span></li>
  );

  let listElements = Array.from({ length: numPages }).map((_, idx) => {
    const linkClass = (idx + 1 === page) ? 'here' : '';
    return (
      <li key={`pagination-${idx}`}>
        <Link to={ buildLinkPath(basePath, idx + 1, sortSlug) } className={linkClass}>
          <span className="label">{idx + 1}</span>
        </Link>
      </li>
    )
  });

  if (numPages > 7) {
    if ((page >= 5) && (numPages - page >= 4)) {
      listElements = [
        firstPageElement,
        emptyElement,
        listElements[page - 2],
        listElements[page - 1],
        listElements[page],
        emptyElement,
        lastPageElement
      ];
    } else if (page >= 5) {
      listElements = [
        firstPageElement,
        emptyElement,
        ...listElements.slice(numPages - 5, numPages)
      ];
    } else if (numPages - page >= 4) {
      listElements = [
        ...listElements.slice(0, 5),
        emptyElement,
        lastPageElement
      ];
    }
  }

  if (page > 1) {
    listElements.unshift((
      <li>
        <Link to={ buildLinkPath(basePath, page - 1, sortSlug) }>«</Link>
      </li>
    ));
  }

  if (page < numPages) {
    listElements.push((
      <li>
        <Link to={ buildLinkPath(basePath, page + 1, sortSlug) }>»</Link>
      </li>
    ))
  }

  return listElements;
}

const Pagination = (props) => {
  const listElements = buildList(props.currentPage, props.numPages, props.basePath, props.sortSlug);

  return (
    <ul className="pagination">
      {listElements}
    </ul>
  );
}

export default Pagination;